"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_SIZE = exports.TEXT_COLOR = exports.MIN_TEXT = exports.MAX_TEXT = exports.EMOJI_SCORING_DATA = exports.EMOJIS = void 0;
var _static = require("./static");
var EMOJIS = {
  ANGRY_INACTIVE: _static.AngryInactive,
  ANGRY_ACTIVE: _static.AngryActive,
  SAD_INACTIVE: _static.SadInactive,
  SAD_ACTIVE: _static.SadActive,
  OKAY_INACTIVE: _static.OkayInactive,
  OKAY_ACTIVE: _static.OkayActive,
  HAPPY_INACTIVE: _static.HappyInactive,
  HAPPY_ACTIVE: _static.HappyActive,
  LOVEDIT_INACTIVE: _static.LovedItInactive,
  LOVEDIT_ACTIVE: _static.LovedItActive
};
exports.EMOJIS = EMOJIS;
var EMOJI_SCORING_DATA = [{
  emoji_inactive: 'ANGRY_INACTIVE',
  emoji_active: 'ANGRY_ACTIVE',
  value: 1
}, {
  emoji_inactive: 'SAD_INACTIVE',
  emoji_active: 'SAD_ACTIVE',
  value: 2
}, {
  emoji_inactive: 'OKAY_INACTIVE',
  emoji_active: 'OKAY_ACTIVE',
  value: 3
}, {
  emoji_inactive: 'HAPPY_INACTIVE',
  emoji_active: 'HAPPY_ACTIVE',
  value: 4
}, {
  emoji_inactive: 'LOVEDIT_INACTIVE',
  emoji_active: 'LOVEDIT_ACTIVE',
  value: 5
}];
exports.EMOJI_SCORING_DATA = EMOJI_SCORING_DATA;
var MIN_TEXT = 'Very dissatisfied';
exports.MIN_TEXT = MIN_TEXT;
var MAX_TEXT = 'Very Satisfied';
exports.MAX_TEXT = MAX_TEXT;
var TEXT_COLOR = 'greyDark';
exports.TEXT_COLOR = TEXT_COLOR;
var TEXT_SIZE = 'small';
exports.TEXT_SIZE = TEXT_SIZE;